// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { PostBrowserDeidleData, PostBrowserDeidleResponse, PostBrowserAckNotificationData, PostBrowserAckNotificationResponse, PostDebugSendSseData, PostDebugSendSseResponse, PostDebugSendNotificationData, PostDebugSendNotificationResponse, PostLoginLoginData, PostLoginLoginResponse, PostLoginDeviceLoginData, PostLoginDeviceLoginResponse, PostLoginDevicePasswordLoginData, PostLoginDevicePasswordLoginResponse, PostLoginPasswordLoginData, PostLoginPasswordLoginResponse, PostLoginSsoCallbackData, PostLoginSsoCallbackResponse, GetLoginSsoDirectCallbackData, GetLoginSsoDirectCallbackResponse, PostLoginRenewData, PostLoginRenewResponse, PostLoginLogoutData, PostLoginLogoutResponse, GetIdentityGetIdentityData, GetIdentityGetIdentityResponse, PutIdentitySetPasswordData, PutIdentitySetPasswordResponse, GetIdentityGetFingerprintsData, GetIdentityGetFingerprintsResponse, PostIdentityEnrollFingerprintData, PostIdentityEnrollFingerprintResponse, DeleteIdentityDeleteFingerprintsData, DeleteIdentityDeleteFingerprintsResponse, GetAuthAuthzData, GetAccountsListData, GetAccountsListResponse, PostAccountsCreateData, PostAccountsCreateResponse, GetAccountsLookupData, GetAccountsLookupResponse, DeleteAccountsDeleteData, DeleteAccountsDeleteResponse, PutAccountsUpdateData, PutAccountsUpdateResponse, PutAccountsUpdatePermissionsData, PutAccountsUpdatePermissionsResponse, GetRolesListData, GetRolesListResponse, PostRolesCreateData, PostRolesCreateResponse, DeleteRolesDeleteData, DeleteRolesDeleteResponse, PutRolesUpdateData, PutRolesUpdateResponse, PutRolesUpdatePermissionsData, PutRolesUpdatePermissionsResponse, GetInstallsIndexData, GetInstallsIndexResponse, PostInstallsCreateData, PostInstallsCreateResponse, PostInstallsDetectInstallData, PostInstallsDetectInstallResponse, PostInstallsAuthCredentialsData, PostInstallsAuthCredentialsResponse, PostInstallsAuthFpData, PostInstallsAuthFpResponse, PostProxyOidcGenerateStartUrlData, PostProxyOidcGenerateStartUrlResponse, PostProxyOidcStartData, PostProxyOidcStartResponse, GetProxyOidcCallbackData, GetProxyOidcCallbackResponse, PostProxyOidcRenewData, PostProxyOidcRenewResponse, GetIdpConfigGetIdpConfigData, GetIdpConfigGetIdpConfigResponse, PostIdpConfigSetupIdpConfigData, PostIdpConfigSetupIdpConfigResponse, PostIdpConfigCompleteIdpSetupData, PostIdpConfigCompleteIdpSetupResponse, PostIdpConfigUnlinkIdpData, PostIdpConfigUnlinkIdpResponse, GetIdpGetUsersData, GetIdpGetUsersResponse, PostIdpImportMatchedUsersData, PostIdpImportMatchedUsersResponse, GetMspGetMspTenantsData, GetMspGetMspTenantsResponse, GetOidcDiscoveryGetOidcConfigurationData, GetOidcDiscoveryGetJwksData, GetPermissionsGetData, GetPermissionsGetResponse, PostRpcSignRpcPayloadData, PostRpcSignRpcPayloadResponse, PostRpcGenerateJwtData, PostRpcGenerateJwtResponse, GetRpcFetchAccountDetailsData, GetRpcFetchAccountDetailsResponse, GetRpcFetchRoleAccountsData, GetRpcFetchRoleAccountsResponse, PostPushTokenRegisterPushTokenData, PostPushTokenRegisterPushTokenResponse, GetSseGetStreamData, GetHealthcheckIndexData, GetHealthcheckIndexResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class BrowserApi {
    public static postBrowserDeidle<ThrowOnError extends boolean = false>(options?: Options<PostBrowserDeidleData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostBrowserDeidleResponse, unknown, ThrowOnError>({
            url: '/browser/deidle',
            ...options
        });
    }
    
    public static postBrowserAckNotification<ThrowOnError extends boolean = false>(options: Options<PostBrowserAckNotificationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostBrowserAckNotificationResponse, unknown, ThrowOnError>({
            url: '/browser/notification/{notificationId}/ack',
            ...options
        });
    }
    
}

export class DebugApi {
    public static postDebugSendSse<ThrowOnError extends boolean = false>(options: Options<PostDebugSendSseData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostDebugSendSseResponse, unknown, ThrowOnError>({
            url: '/debug/sse',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postDebugSendNotification<ThrowOnError extends boolean = false>(options: Options<PostDebugSendNotificationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostDebugSendNotificationResponse, unknown, ThrowOnError>({
            url: '/debug/notification',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class LoginApi {
    public static postLoginLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginLoginData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginLoginResponse, unknown, ThrowOnError>({
            url: '/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postLoginDeviceLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginDeviceLoginData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginDeviceLoginResponse, unknown, ThrowOnError>({
            url: '/login/device',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postLoginDevicePasswordLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginDevicePasswordLoginData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginDevicePasswordLoginResponse, unknown, ThrowOnError>({
            url: '/login/device/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postLoginPasswordLogin<ThrowOnError extends boolean = false>(options: Options<PostLoginPasswordLoginData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginPasswordLoginResponse, unknown, ThrowOnError>({
            url: '/login/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postLoginSsoCallback<ThrowOnError extends boolean = false>(options: Options<PostLoginSsoCallbackData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginSsoCallbackResponse, unknown, ThrowOnError>({
            url: '/login/sso',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getLoginSsoDirectCallback<ThrowOnError extends boolean = false>(options: Options<GetLoginSsoDirectCallbackData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetLoginSsoDirectCallbackResponse, unknown, ThrowOnError>({
            url: '/login/sso-callback',
            ...options
        });
    }
    
    public static postLoginRenew<ThrowOnError extends boolean = false>(options: Options<PostLoginRenewData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostLoginRenewResponse, unknown, ThrowOnError>({
            url: '/login/renew',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postLoginLogout<ThrowOnError extends boolean = false>(options?: Options<PostLoginLogoutData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostLoginLogoutResponse, unknown, ThrowOnError>({
            url: '/login/logout',
            ...options
        });
    }
    
}

export class IdentityApi {
    public static getIdentityGetIdentity<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetIdentityData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetIdentityGetIdentityResponse, unknown, ThrowOnError>({
            url: '/identity',
            ...options
        });
    }
    
    public static putIdentitySetPassword<ThrowOnError extends boolean = false>(options: Options<PutIdentitySetPasswordData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutIdentitySetPasswordResponse, unknown, ThrowOnError>({
            url: '/identity/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getIdentityGetFingerprints<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetFingerprintsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetIdentityGetFingerprintsResponse, unknown, ThrowOnError>({
            url: '/identity/fingerprints',
            ...options
        });
    }
    
    public static postIdentityEnrollFingerprint<ThrowOnError extends boolean = false>(options: Options<PostIdentityEnrollFingerprintData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostIdentityEnrollFingerprintResponse, unknown, ThrowOnError>({
            url: '/identity/fingerprint',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteIdentityDeleteFingerprints<ThrowOnError extends boolean = false>(options: Options<DeleteIdentityDeleteFingerprintsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteIdentityDeleteFingerprintsResponse, unknown, ThrowOnError>({
            url: '/identity/fingerprint/{id}',
            ...options
        });
    }
    
}

export class AuthApi {
    public static getAuthAuthz<ThrowOnError extends boolean = false>(options?: Options<GetAuthAuthzData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/authz',
            ...options
        });
    }
    
}

export class AccountsApi {
    public static getAccountsList<ThrowOnError extends boolean = false>(options?: Options<GetAccountsListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetAccountsListResponse, unknown, ThrowOnError>({
            url: '/accounts',
            ...options
        });
    }
    
    public static postAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostAccountsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostAccountsCreateResponse, unknown, ThrowOnError>({
            url: '/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getAccountsLookup<ThrowOnError extends boolean = false>(options?: Options<GetAccountsLookupData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetAccountsLookupResponse, unknown, ThrowOnError>({
            url: '/accounts/lookup',
            ...options
        });
    }
    
    public static deleteAccountsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteAccountsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteAccountsDeleteResponse, unknown, ThrowOnError>({
            url: '/accounts/{id}',
            ...options
        });
    }
    
    public static putAccountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutAccountsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutAccountsUpdateResponse, unknown, ThrowOnError>({
            url: '/accounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putAccountsUpdatePermissions<ThrowOnError extends boolean = false>(options: Options<PutAccountsUpdatePermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutAccountsUpdatePermissionsResponse, unknown, ThrowOnError>({
            url: '/accounts/{id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class RolesApi {
    public static getRolesList<ThrowOnError extends boolean = false>(options?: Options<GetRolesListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetRolesListResponse, unknown, ThrowOnError>({
            url: '/roles',
            ...options
        });
    }
    
    public static postRolesCreate<ThrowOnError extends boolean = false>(options: Options<PostRolesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostRolesCreateResponse, unknown, ThrowOnError>({
            url: '/roles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteRolesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteRolesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteRolesDeleteResponse, unknown, ThrowOnError>({
            url: '/roles/{id}',
            ...options
        });
    }
    
    public static putRolesUpdate<ThrowOnError extends boolean = false>(options: Options<PutRolesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutRolesUpdateResponse, unknown, ThrowOnError>({
            url: '/roles/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putRolesUpdatePermissions<ThrowOnError extends boolean = false>(options: Options<PutRolesUpdatePermissionsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutRolesUpdatePermissionsResponse, unknown, ThrowOnError>({
            url: '/roles/{id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InstallsApi {
    public static getInstallsIndex<ThrowOnError extends boolean = false>(options?: Options<GetInstallsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetInstallsIndexResponse, unknown, ThrowOnError>({
            url: '/installs',
            ...options
        });
    }
    
    public static postInstallsCreate<ThrowOnError extends boolean = false>(options: Options<PostInstallsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInstallsCreateResponse, unknown, ThrowOnError>({
            url: '/installs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postInstallsDetectInstall<ThrowOnError extends boolean = false>(options: Options<PostInstallsDetectInstallData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInstallsDetectInstallResponse, unknown, ThrowOnError>({
            url: '/installs/detect-install',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postInstallsAuthCredentials<ThrowOnError extends boolean = false>(options: Options<PostInstallsAuthCredentialsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInstallsAuthCredentialsResponse, unknown, ThrowOnError>({
            url: '/installs/auth-credentials',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postInstallsAuthFp<ThrowOnError extends boolean = false>(options: Options<PostInstallsAuthFpData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInstallsAuthFpResponse, unknown, ThrowOnError>({
            url: '/installs/auth-fp',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class ProxyOidcApi {
    public static postProxyOidcGenerateStartUrl<ThrowOnError extends boolean = false>(options: Options<PostProxyOidcGenerateStartUrlData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostProxyOidcGenerateStartUrlResponse, unknown, ThrowOnError>({
            url: '/proxy-oidc/generate-start-url',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postProxyOidcStart<ThrowOnError extends boolean = false>(options: Options<PostProxyOidcStartData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostProxyOidcStartResponse, unknown, ThrowOnError>({
            url: '/proxy-oidc/start',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getProxyOidcCallback<ThrowOnError extends boolean = false>(options: Options<GetProxyOidcCallbackData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetProxyOidcCallbackResponse, unknown, ThrowOnError>({
            url: '/proxy-oidc/callback',
            ...options
        });
    }
    
    public static postProxyOidcRenew<ThrowOnError extends boolean = false>(options?: Options<PostProxyOidcRenewData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostProxyOidcRenewResponse, unknown, ThrowOnError>({
            url: '/proxy-oidc/renew',
            ...options
        });
    }
    
}

export class IdpConfigApi {
    public static getIdpConfigGetIdpConfig<ThrowOnError extends boolean = false>(options?: Options<GetIdpConfigGetIdpConfigData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetIdpConfigGetIdpConfigResponse, unknown, ThrowOnError>({
            url: '/idp/config',
            ...options
        });
    }
    
    public static postIdpConfigSetupIdpConfig<ThrowOnError extends boolean = false>(options: Options<PostIdpConfigSetupIdpConfigData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostIdpConfigSetupIdpConfigResponse, unknown, ThrowOnError>({
            url: '/idp/config/setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postIdpConfigCompleteIdpSetup<ThrowOnError extends boolean = false>(options: Options<PostIdpConfigCompleteIdpSetupData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostIdpConfigCompleteIdpSetupResponse, unknown, ThrowOnError>({
            url: '/idp/config/complete-setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postIdpConfigUnlinkIdp<ThrowOnError extends boolean = false>(options?: Options<PostIdpConfigUnlinkIdpData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostIdpConfigUnlinkIdpResponse, unknown, ThrowOnError>({
            url: '/idp/config/unlink',
            ...options
        });
    }
    
}

export class IdpApi {
    public static getIdpGetUsers<ThrowOnError extends boolean = false>(options?: Options<GetIdpGetUsersData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetIdpGetUsersResponse, unknown, ThrowOnError>({
            url: '/idp/users',
            ...options
        });
    }
    
    public static postIdpImportMatchedUsers<ThrowOnError extends boolean = false>(options?: Options<PostIdpImportMatchedUsersData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostIdpImportMatchedUsersResponse, unknown, ThrowOnError>({
            url: '/idp/import-matched',
            ...options
        });
    }
    
}

export class MspApi {
    public static getMspGetMspTenants<ThrowOnError extends boolean = false>(options?: Options<GetMspGetMspTenantsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetMspGetMspTenantsResponse, unknown, ThrowOnError>({
            url: '/msp/tenants',
            ...options
        });
    }
    
}

export class OidcDiscoveryApi {
    public static getOidcDiscoveryGetOidcConfiguration<ThrowOnError extends boolean = false>(options?: Options<GetOidcDiscoveryGetOidcConfigurationData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/.well-known/openid-configuration',
            ...options
        });
    }
    
    public static getOidcDiscoveryGetJwks<ThrowOnError extends boolean = false>(options?: Options<GetOidcDiscoveryGetJwksData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/.well-known/jwks.json',
            ...options
        });
    }
    
}

export class PermissionsApi {
    public static getPermissionsGet<ThrowOnError extends boolean = false>(options?: Options<GetPermissionsGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetPermissionsGetResponse, unknown, ThrowOnError>({
            url: '/permissions',
            ...options
        });
    }
    
}

export class RpcApi {
    public static postRpcSignRpcPayload<ThrowOnError extends boolean = false>(options: Options<PostRpcSignRpcPayloadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostRpcSignRpcPayloadResponse, unknown, ThrowOnError>({
            url: '/rpc/sign',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postRpcGenerateJwt<ThrowOnError extends boolean = false>(options: Options<PostRpcGenerateJwtData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostRpcGenerateJwtResponse, unknown, ThrowOnError>({
            url: '/rpc/generate-jwt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getRpcFetchAccountDetails<ThrowOnError extends boolean = false>(options: Options<GetRpcFetchAccountDetailsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetRpcFetchAccountDetailsResponse, unknown, ThrowOnError>({
            url: '/rpc/fetch-account-details',
            ...options
        });
    }
    
    public static getRpcFetchRoleAccounts<ThrowOnError extends boolean = false>(options: Options<GetRpcFetchRoleAccountsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetRpcFetchRoleAccountsResponse, unknown, ThrowOnError>({
            url: '/rpc/fetch-role-accounts',
            ...options
        });
    }
    
}

export class PushTokenApi {
    public static postPushTokenRegisterPushToken<ThrowOnError extends boolean = false>(options: Options<PostPushTokenRegisterPushTokenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostPushTokenRegisterPushTokenResponse, unknown, ThrowOnError>({
            url: '/push-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SseApi {
    public static getSseGetStream<ThrowOnError extends boolean = false>(options?: Options<GetSseGetStreamData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sse',
            ...options
        });
    }
    
}

export class HealthcheckApi {
    public static getHealthcheckIndex<ThrowOnError extends boolean = false>(options?: Options<GetHealthcheckIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetHealthcheckIndexResponse, unknown, ThrowOnError>({
            url: '/healthz',
            ...options
        });
    }
    
}